/* Flouven - ajustes de comportamiento (tarjetas y ficha de producto) */
(function () {
  /* ------------------------------------------------------------------------------------------------------------------
     Featured collection y Mosaic grid con auto-cambio a la 2a imagen: en escritorio, el hover va a la OTRA imagen
     (1<->2) y se queda ahi mientras dure. Antes el hover del tema ocultaba la principal y la tarjeta quedaba vacia.
     ------------------------------------------------------------------------------------------------------------------ */
  var AUTOSWAP_SECTIONS = '.shopify-section--featured-collections, .shopify-section--flouven-mosaic-grid';

  function bindCards(cards) {
    cards.forEach(function (card) {
      if (card.__flHoverBound) return;
      card.__flHoverBound = true;
      card.addEventListener('mouseenter', function () {
        var showing2 = card.classList.contains('fl-show-2nd');
        card.classList.add(showing2 ? 'fl-hover-1' : 'fl-hover-2');
      });
      card.addEventListener('mouseleave', function () {
        card.classList.remove('fl-hover-1');
        card.classList.remove('fl-hover-2');
      });
    });
  }

  function cardsWithSecondary(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('.product-card'))
      .filter(function (c) { return c.querySelector('.product-card__image--secondary'); });
  }

  function initSection(section) {
    if (section.__flHoverInit) return;
    var cards = cardsWithSecondary(section);
    if (!cards.length) return;
    // Solo si el auto-cambio esta activo: la 2a imagen es una capa absoluta
    var cs = getComputedStyle(cards[0].querySelector('.product-card__image--secondary'));
    if (cs.position !== 'absolute') return;
    section.__flHoverInit = true;
    var isSlide = cs.transform && cs.transform !== 'none';
    if (!section.id) section.id = 'fl-sec-' + Math.random().toString(36).slice(2);
    var sel = '#' + section.id;
    var rules = [
      '@media screen and (pointer: fine){',
      sel + ' .product-card__figure:has(.product-card__image--secondary):hover > .product-card__media .product-card__image--primary{opacity:1;}',
      sel + ' .product-card__image--secondary{mix-blend-mode:normal;}'
    ];
    if (isSlide) {
      rules.push(sel + ' .product-card.fl-hover-2 .product-card__image--primary{transform:translateX(-100%)!important;opacity:1!important;}');
      rules.push(sel + ' .product-card.fl-hover-2 .product-card__image--secondary{transform:translateX(0)!important;opacity:1!important;}');
      rules.push(sel + ' .product-card.fl-hover-1 .product-card__image--primary{transform:translateX(0)!important;opacity:1!important;}');
      rules.push(sel + ' .product-card.fl-hover-1 .product-card__image--secondary{transform:translateX(100%)!important;opacity:1!important;}');
    } else {
      rules.push(sel + ' .product-card.fl-hover-2 .product-card__image--primary{opacity:1!important;}');
      rules.push(sel + ' .product-card.fl-hover-2 .product-card__image--secondary{opacity:1!important;}');
      rules.push(sel + ' .product-card.fl-hover-1 .product-card__image--primary{opacity:1!important;}');
      rules.push(sel + ' .product-card.fl-hover-1 .product-card__image--secondary{opacity:0!important;}');
    }
    rules.push('}');
    var style = document.createElement('style');
    style.textContent = rules.join('');
    section.appendChild(style);
    bindCards(cards);
    // Colecciones que se pintan al pulsar su boton
    section.addEventListener('fl:collection-hydrated', function (e) {
      bindCards(cardsWithSecondary((e.detail && e.detail.item) || section));
    });
  }

  function initHover() {
    if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;
    Array.prototype.slice.call(document.querySelectorAll(AUTOSWAP_SECTIONS)).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHover);
  } else {
    initHover();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(AUTOSWAP_SECTIONS)) {
      t.__flHoverInit = false;
      initSection(t);
    }
  });

  /* ------------------------------------------------------------------------------------------------------------------
     Ficha de producto: con los enlaces en la columna izquierda, los paneles (envios, guia de tallas...) se pintan dos
     veces con el mismo id. Cada panel escucha los clics de su boton, asi que se abrian los dos y habia que cerrar dos
     veces. Abrimos solo el panel de la misma columna que el boton pulsado.
     ------------------------------------------------------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[aria-controls^="info-drawer-"]');
    if (!btn) return;
    var drawers = document.querySelectorAll('[id="' + btn.getAttribute('aria-controls') + '"]');
    if (drawers.length < 2) return;
    // capture en document: llega antes que los paneles del tema (escuchan en body) y no les dejamos abrirse los dos
    e.stopPropagation();
    e.preventDefault();
    var column = btn.closest('.product-info-extra, .product-info');
    var drawer = drawers[0];
    for (var i = 0; i < drawers.length; i++) {
      if (column && column.contains(drawers[i])) { drawer = drawers[i]; break; }
    }
    if (drawer.open) { drawer.hide(); } else { drawer.show(); }
  }, true);

  /* ------------------------------------------------------------------------------------------------------------------
     Ficha de producto: al cambiar de talla el tema sustituye los botones de compra y Shopify reconstruye "Comprar
     ahora" (parpadeo). Su HTML no depende de la talla (la talla sale del formulario al pulsar), asi que si los botones
     nuevos son iguales que los actuales (mismo texto, mismo estado) se dejan los que hay.
     ------------------------------------------------------------------------------------------------------------------ */
  function buyButtonsSignature(el) {
    return Array.prototype.slice.call(el.querySelectorAll('button'))
      .filter(function (b) { return !b.closest('.shopify-payment-button'); })
      .map(function (b) { return b.outerHTML.replace(/\s+/g, ' '); })
      .join('') + '|' + el.querySelectorAll('.shopify-payment-button').length;
  }

  document.addEventListener('product:rerender', function (e) {
    var detail = e.detail;
    var fragment = detail && detail.htmlFragment;
    if (!fragment || detail.productChange) return;
    document.querySelectorAll('product-rerender [data-block-type="buy-buttons"]').forEach(function (block) {
      var current = block.querySelector('buy-buttons');
      var blockId = block.getAttribute('data-block-id');
      var next = fragment.querySelector('[data-block-type="buy-buttons"][data-block-id="' + blockId + '"]');
      var nextButtons = next && next.querySelector('buy-buttons');
      if (!current || !nextButtons) return;
      // sin el bloque en la respuesta, el tema no toca los botones actuales
      if (buyButtonsSignature(current) === buyButtonsSignature(nextButtons)) next.remove();
    });
  }, true);

  /* ------------------------------------------------------------------------------------------------------------------
     Selector de tallas: recuadro negro bajo la talla elegida que se desliza de una talla a otra en 0,5 s.
     Al cambiar de variante el tema vuelve a pintar el selector (los elementos se sustituyen), asi que el estado de la
     animacion se guarda por grupo de tallas (nombre de los radios) y se aplica al recuadro que exista en cada momento.
     ------------------------------------------------------------------------------------------------------------------ */
  var SIZE_ANIM_MS = 500;
  var sizeState = {};
  var stepping = false;

  function isSizeBox(box) { return !!box.querySelector(':scope > .block-swatch'); }

  function sizeKey(box) {
    var input = box.querySelector(':scope > input[type="radio"]');
    return input && input.name;
  }

  function checkedRect(box) {
    var input = box.querySelector(':scope > input:checked');
    var label = input && input.nextElementSibling;
    if (!label || !label.classList.contains('block-swatch')) return null;
    return { x: label.offsetLeft, y: label.offsetTop, w: label.offsetWidth, h: label.offsetHeight };
  }

  function indicatorOf(box) {
    var ind = box.querySelector(':scope > .fl-size-indicator');
    if (!ind) {
      ind = document.createElement('span');
      ind.className = 'fl-size-indicator';
      ind.setAttribute('aria-hidden', 'true');
      ind.__flFresh = true;
      box.insertBefore(ind, box.firstChild);
      box.classList.add('fl-size-ready');
    }
    observeSizeBox(box);
    return ind;
  }

  function paintSize(key) {
    var s = sizeState[key];
    document.querySelectorAll('.variant-picker__option-values.fl-size-ready').forEach(function (box) {
      if (sizeKey(box) !== key) return;
      var ind = indicatorOf(box);
      box.classList.toggle('fl-size-moving', !!s.anim);
      if (!s.cur) { ind.style.opacity = '0'; ind.__flFresh = false; return; }
      // recuadro recien creado tras un repintado del tema: aparece ya visible, sin fundido
      if (ind.__flFresh) ind.style.transition = 'none';
      ind.style.width = s.cur.w + 'px';
      ind.style.height = s.cur.h + 'px';
      ind.style.transform = 'translate(' + s.cur.x + 'px,' + s.cur.y + 'px)';
      ind.style.opacity = '1';
      if (ind.__flFresh) { ind.__flFresh = false; void ind.offsetWidth; ind.style.transition = ''; }
    });
  }

  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  // siguiente fotograma: requestAnimationFrame, con un setTimeout de respaldo por si el navegador no esta pintando
  function nextFrame(fn) {
    var done = false;
    function run() { if (!done) { done = true; fn(); } }
    requestAnimationFrame(run);
    setTimeout(run, 34);
  }

  function step() {
    var running = false;
    Object.keys(sizeState).forEach(function (key) {
      var s = sizeState[key], a = s.anim;
      if (!a) return;
      var t = Math.min(1, (performance.now() - a.start) / SIZE_ANIM_MS), e = ease(t);
      s.cur = {
        x: a.from.x + (a.to.x - a.from.x) * e,
        y: a.from.y + (a.to.y - a.from.y) * e,
        w: a.from.w + (a.to.w - a.from.w) * e,
        h: a.from.h + (a.to.h - a.from.h) * e
      };
      if (t >= 1) { s.cur = a.to; s.anim = null; } else { running = true; }
      paintSize(key);
    });
    if (running) { nextFrame(step); } else { stepping = false; }
  }

  function moveSize(box, animate) {
    var key = sizeKey(box);
    if (!key) return;
    indicatorOf(box);
    var s = sizeState[key] || (sizeState[key] = {});
    var to = checkedRect(box);
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!to) {
      s.cur = null; s.anim = null;
    } else if (animate && s.cur && !reduced && (s.cur.x !== to.x || s.cur.y !== to.y)) {
      var anim = s.anim = { from: s.cur, to: to, start: performance.now() };
      if (!stepping) { stepping = true; nextFrame(step); }
      // si la pestana no pinta (segundo plano), requestAnimationFrame no corre: se termina igualmente
      setTimeout(function () {
        if (s.anim !== anim) return;
        s.cur = to; s.anim = null; paintSize(key);
      }, SIZE_ANIM_MS + 100);
    } else {
      s.cur = to; s.anim = null;
    }
    paintSize(key);
  }

  function scanSizes() {
    document.querySelectorAll('.variant-picker__option-values').forEach(function (box) {
      if (!isSizeBox(box)) return;
      var key = sizeKey(box);
      if (!box.classList.contains('fl-size-ready')) {
        var s = sizeState[key];
        // selector recien pintado por el tema: si hay animacion en curso, continua en el nuevo
        if (s && s.anim) { indicatorOf(box); paintSize(key); } else { moveSize(box, false); }
      }
    });
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('.variant-picker__option-values');
    if (box && isSizeBox(box)) moveSize(box, true);
  }, true);

  // Se procesa en el propio aviso del observer (antes de pintar): con un setTimeout el selector nuevo que pinta el tema
  // se veia unos milisegundos sin recuadro y la talla nueva parpadeaba
  document.documentElement.classList.add('fl-size-js');
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes.length) { scanSizes(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  function remeasureSizes() {
    document.querySelectorAll('.variant-picker__option-values.fl-size-ready').forEach(function (box) {
      var s = sizeState[sizeKey(box)];
      if (!s || !s.anim) moveSize(box, false);
    });
  }

  window.addEventListener('resize', remeasureSizes);
  // en movil la fila de tallas termina de colocarse despues (fuentes, imagenes): se vuelve a medir para que el
  // recuadro no se quede desplazado y la letra blanca caiga fuera de el
  // custom.js desmarca la talla preseleccionada sin lanzar 'change': tambien hay que quitar el recuadro entonces
  window.addEventListener('load', remeasureSizes);
  document.addEventListener('DOMContentLoaded', function () { setTimeout(remeasureSizes, 0); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasureSizes);
  var sizeRO = window.ResizeObserver && new ResizeObserver(function () { remeasureSizes(); });
  function observeSizeBox(box) {
    if (!sizeRO || box.__flObserved) return;
    box.__flObserved = true;
    sizeRO.observe(box);
    box.querySelectorAll(':scope > .block-swatch').forEach(function (l) { sizeRO.observe(l); });
  }

  /* ------------------------------------------------------------------------------------------------------------------
     Carrito: al quitar el ultimo producto el tema desvanece el cuerpo y el pie del carrito, cambia el contenido y solo
     vuelve a mostrar el cuerpo. El pie (donde va el carrusel de Best Sellers de la cesta vacia) se quedaba con
     opacity 0 y desplazado 30px, asi que el carrusel no se veia hasta recargar. Se vuelve a mostrar aqui.
     ------------------------------------------------------------------------------------------------------------------ */
  document.addEventListener('cart-drawer:refreshed', function (e) {
    var drawer = e.target;
    var footer = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="footer"]');
    if (!footer || !drawer.querySelector('.cart-drawer__empty')) return;
    footer.getAnimations().forEach(function (a) { a.cancel(); });
    footer.style.opacity = '';
    footer.style.transform = '';
    if (footer.animate) {
      footer.animate(
        { opacity: [0, 1], transform: ['translateY(30px)', 'translateY(0)'] },
        { duration: 250, easing: 'cubic-bezier(.25, .46, .45, .94)' }
      );
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanSizes);
  } else {
    scanSizes();
  }
})();

/* ----------------------------------------------------------------------------------------------------------------------
   Compra rapida (boton + de las tarjetas): el tema descargaba la ficha entera del producto (~950 KB) para sacar el
   desplegable, y al abrirlo precargaba otra ficha entera por cada talla. Con varios productos eran decenas de MB: tardaba
   en abrir y Chrome en movil llegaba a recargar la pestana. Ahora se pide la plantilla product.fl-quick (sin layout,
   solo el desplegable, ~35 KB) y se empieza a descargar al tocar el boton, antes de soltarlo.
   ---------------------------------------------------------------------------------------------------------------------- */
(function () {
  var VIEW = 'fl-quick';
  var MAX_CACHED = 12;
  var cache = new Map();

  function quickUrl(handle) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var parts = handle.split('?');
    return root + 'products/' + parts[0] + '?' + (parts[1] ? parts[1] + '&' : '') + 'view=' + VIEW;
  }

  function load(handle) {
    var url = quickUrl(handle);
    if (cache.has(url)) return cache.get(url);
    var promise = fetch(url).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
    promise.catch(function () { cache.delete(url); });
    cache.set(url, promise);
    if (cache.size > MAX_CACHED) cache.delete(cache.keys().next().value);
    return promise;
  }

  // Selectores de talla del desplegable: las peticiones ?option_values= sin section_id son las del contexto quick_buy
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    if (typeof input === 'string' && /\/products\/[^?#]+\?option_values=/.test(input) && input.indexOf('section_id=') === -1 && input.indexOf('view=') === -1) {
      input += '&view=' + VIEW;
    }
    return nativeFetch.call(this, input, init);
  };

  customElements.whenDefined('quick-buy-modal').then(function () {
    var QuickBuyModal = customElements.get('quick-buy-modal');
    var modalShow = Object.getPrototypeOf(QuickBuyModal.prototype).show;

    QuickBuyModal.prototype.show = async function () {
      var root = document.documentElement;
      root.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
      var html;
      try {
        html = await load(this.getAttribute('handle'));
      } finally {
        root.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
      var template = new DOMParser().parseFromString(html, 'text/html').getElementById('quick-buy-content');
      if (!template) return;
      var content = template.content;
      content.querySelectorAll('noscript').forEach(function (n) { n.remove(); });
      this.replaceChildren(content);
      if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      return modalShow.call(this);
    };
  });

  // Se empieza a descargar al tocar (o pasar el raton por) el boton +, antes del clic
  function prefetch(e) {
    var btn = e.target.closest && e.target.closest('.product-card__quick-add-button[aria-controls]');
    var modal = btn && document.getElementById(btn.getAttribute('aria-controls'));
    if (modal && modal.matches('quick-buy-modal') && modal.getAttribute('handle')) load(modal.getAttribute('handle'));
  }

  document.addEventListener('touchstart', prefetch, { passive: true, capture: true });
  document.addEventListener('pointerdown', prefetch, true);
  document.addEventListener('mouseover', prefetch, { passive: true });
})();
